import React from 'react';
import { Mail } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:contact@outofthepark.in';
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-content animate-fadeInUp">
          <h2 className="contact-title">Let's Connect</h2>
          <p className="contact-subtitle">
            Ready to transform your sports business? Get in touch with our team.
          </p>
          <button onClick={handleEmailClick} className="contact-button">
            <Mail size={20} />
            contact@outofthepark.in
          </button>
        </div>
      </div>
    </section>
  );
};

export default Contact;